import React from 'react';
import { Box } from '@mui/material';

type GridContentProps = {
    children: React.ReactNode;
}

/**
 * A MUI `Box` component with standard padding for
 * content in a `Grid` layout.
 * Smaller padding at mobile sizes (below xs).
 */
const GridContent: React.FC<GridContentProps> = ({ children }: GridContentProps) => (
  <Box sx= {{ p: {xs: '1rem', sm:'1.5rem'} }} >
    {children}
  </Box>
);

export default GridContent;